import { ContentBlock, ContentState, DraftDecorator } from 'draft-js';
import { DraftDecoratorComponentProps, EntityTypes, RichEditorVariable } from '../types';
import { findEntity, findVariable } from '../utils';
import React from 'react';

const createVariableEntityStrategy = () => {
    return (contentBlock: ContentBlock, callback: (start: number, end: number) => void, contentState: ContentState) => {
        findEntity(contentBlock, contentState, EntityTypes.Variable, callback);
    };
};

const VariableValueSpan = (props: DraftDecoratorComponentProps & { variables?: RichEditorVariable[] }) => {
    const { contentState, entityKey, variables } = props;
    let value: string | undefined;
    if (entityKey) {
        const entity = contentState.getEntity(entityKey);
        if (entity.getType() === EntityTypes.Variable) {
            const data: RichEditorVariable = entity.getData();
            const foundVar = Array.isArray(data.name)
                ? data.name.map((name) => findVariable(name, variables)).find((variable) => Boolean(variable))
                : findVariable(data.name, variables);
            value = foundVar?.value ?? data.displayText ?? (Array.isArray(data.name) ? data.name[0] : data.name);
        }
    }

    return <span className="rain-editor-variable">{value || props.children}</span>;
};

const VariableNameSpan = (props: DraftDecoratorComponentProps) => {
    return <span className="rain-editor-variable">{props.children}</span>;
};

export const getVariableEntityDecorator = ({
    focused,
    variables,
}: {
    focused: boolean;
    variables?: RichEditorVariable[];
}): DraftDecorator => {
    return {
        strategy: createVariableEntityStrategy(),
        component: focused ? VariableNameSpan : VariableValueSpan,
        props: { variables },
    };
};
